export const DEPARTMENTS = [
  "Development", "Design & Engineering", "Tool Room", "PPC", "Business", "Sales & Marketing",
  "Procurement", "Stores & Inventory", "QC", "Production", "Maintenance",
  "Dispatch & Logistics", "Finance & Accounts", "HR & Admin",
];

export const DEPARTMENT_COLORS = {
  Development: "#38bdf8",
  "Design & Engineering": "#6366f1",
  "Tool Room": "#f59e0b",
  PPC: "#d946ef",
  Business: "#8b5cf6",
  "Sales & Marketing": "#db2777",
  Procurement: "#10b981",
  "Stores & Inventory": "#a16207",
  QC: "#f43f5e",
  Production: "#0a1f5c",
  Maintenance: "#ea580c",
  "Dispatch & Logistics": "#0d9488",
  "Finance & Accounts": "#65a30d",
  "HR & Admin": "#64748b",
};

export const ROLES = ["admin", "pm", "team_member"];
export const ROLE_LABELS = { admin: "Admin", pm: "Project Manager", team_member: "Team Member" };

export const PROJECT_STATUSES = ["Concept", "Design", "Tool Dev", "Prototype", "Testing", "Production", "Completed", "On Hold", "Cancelled"];
export const PHASE_STATUSES = ["Not Started", "In Progress", "On Hold", "Completed"];
export const TASK_STATUSES = ["Not Started", "In Progress", "Blocked", "Completed", "Overdue"];
export const TASK_TYPES = [
  "Design", "Costing / Quotation", "Tool Design", "Tool Development / Trial", "Prototyping / Sampling", "Customer Approval (PPAP/FAI)",
  "Sourcing", "Raw Material Procurement",
  "Cutting (Laser / Shearing)", "Bending / Forming", "Welding", "Machining", "Surface Treatment", "Manufacturing",
  "Quality Check", "Testing",
  "Assembly", "Packaging", "Dispatch & Logistics", "Rework / Rectification", "Other",
];
export const TASK_PRIORITIES = ["Critical", "High", "Medium", "Low"];
export const MILESTONE_STATUSES = ["Pending", "Achieved", "Missed"];

export const STATUS_COLORS = {
  "Not Started": "#94a3b8",
  "In Progress": "#2563eb",
  Blocked: "#eab308",
  Completed: "#16a34a",
  Overdue: "#dc2626",
};

export const PRIORITY_COLORS = {
  Critical: "#dc2626",
  High: "#f59e0b",
  Medium: "#38bdf8",
  Low: "#94a3b8",
};
